import styles from './CustomStyles.module.scss';

export const theme = 'Sportscraft';

export const customClasses = {
  nostoItemButton: styles.nostoItemButton,
  after: styles.nostoSelectArrow,
  additionalField: styles.nostoItemSelect,
};

export const nostoListsSliderOptions = {
  spaceBetween: 12,
  slidesPerView: 1.22,
  slidesOffsetAfter: 20,
  slidesOffsetBefore: 20,
  breakpoints: {
    320: {
      slidesPerView: 1.15,
    },
    768: {
      slidesPerView: 1.2,
    },
  },
}

export const wishListButtonText = 'Add to Wishlist';
